// PhonicsLt15.js
// 包装组件：Letter Teams L15
// 路由：/phonics/lt15
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt15 } from './phonics/phonics_data_lt15';

function PhonicsLt15() {
  return <PhonicsLt letterData={letterDataLt15} />;
}

export default PhonicsLt15;
